<template>
    <div>
        <div class="schema mb-2" v-if="isTowel">
            <img alt src="/images/svg/towels.svg"/>
        </div>
        <div class="schema mb-2" v-else-if="isPillowFilling">
            <span class="schema-pillow-dims">{{$t('components.ProductTypeImage.filling')}}</span>
            <img alt src="/images/svg/pillow-dims.svg"/>
        </div>
        <div class="schema mb-2" v-else-if="isDuvetFilling">
            <span class="schema-duvet-dims">{{$t('components.ProductTypeImage.filling')}}</span>
            <img alt src="/images/svg/duvet-dims.svg"/>
        </div>
        <div class="schema mb-2" v-else-if="isPillow">
            <span class="schema-pillow-dims">{{$t('components.ProductTypeImage.filling')}}</span>
            <img alt src="/images/svg/pillow-dims.svg"/>
            <br>
            <a class="link-underline " :href="howToMessureURL" target="_blank">{{$t('components.ProductTypeImage.howToMessureCorrectly')}}</a>
        </div>
        <div class="schema mb-2" v-else-if="isDuvet">
            <span class="schema-duvet-dims">{{$t('components.ProductTypeImage.filling')}}</span>
            <img alt src="/images/svg/duvet-dims.svg"/>
            <br>
            <a class="link-underline " :href="howToMessureURL" target="_blank">{{$t('components.ProductTypeImage.howToMessureCorrectly')}}</a>
        </div>
        <div class="schema mb-2" v-else-if="isCoverDim">
            <img alt src="/images/svg/cover-dims.svg"/>
            <br>
            <a class="link-underline " :href="howToMessureURL" target="_blank">{{$t('components.ProductTypeImage.howToMessureCorrectly')}}</a>
        </div>
        <div class="schema mb-2" v-else-if="isBathrobe">
            <img alt src="/images/svg/bathrobe.svg"/>
            <br>
            <a
                class="link-underline "
                target="_blank"
                @click.prevent="showHowToMeasurePopup = true"
                href="#"
            >{{$t('components.ProductTypeImage.howToMessureCorrectly')}}</a>
        </div>

        <how-to-measure-popup
                :show="showHowToMeasurePopup"
                @cancel="showHowToMeasurePopup = false"
        ></how-to-measure-popup>
    </div>
</template>

<script>
    import HowToMeasurePopup from "./HowToMeasurePopup";
    export default {
        components: {HowToMeasurePopup},
        props: ["productType"],
        data: function() {
            return {
                showHowToMeasurePopup: false
            }
        },
        computed: {
            isTowel: function () {
                return this.productType.id === 1
                    || this.productType.id === 2;
            },
            isPillowFilling: function () {
                return this.productType.id === 3;
            },
            isDuvetFilling: function () {
                return this.productType.id === 4;
            },
            isPillow: function () {
                return this.productType.id === 5;
            },
            isDuvet: function () {
                return this.productType.id === 6;
            },
            isCoverDim: function () {
                return this.productType.id === 7;
            },
            isBathrobe: function () {
                return this.productType.id === 8;
            },
            howToMessureURL: function () {
                return URLSource.howToMessure;
            }
        }
    };
</script>